import { Component, Inject, OnInit } from '@angular/core';

import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { AuthFacade } from '@cigna/chcp/auth/data-access';
import { TinLob } from '@cigna/chcp/shared/util';

import { ManageUserAccessFacade } from '../+state/manage-user-access.facade';
import { User } from '../manage-access.model';

@Component({
  selector: 'cigna-dialog-user-remove-access',
  templateUrl: './dialog-user-remove-access.component.html',
  styleUrls: ['./dialog-user-remove-access.component.scss'],
})
export class DialogUserRemoveAccessComponent implements OnInit {
  impersonator$ = this.authFacade.isImpersonator$;
  removeAccessView$ = this.manageAccessFacade.removeAccessView$;

  selectedTins: TinLob[];

  constructor(
    public dialogRef: MatDialogRef<DialogUserRemoveAccessComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { user: User },
    private manageAccessFacade: ManageUserAccessFacade,
    private authFacade: AuthFacade,
  ) {}

  ngOnInit() {
    this.selectedTins = [];
  }

  updateSelections(tins: TinLob[]) {
    this.selectedTins = tins;
  }

  onRemove(): void {
    this.manageAccessFacade.removeAccess({
      userId: this.data.user.id,
      tins: this.selectedTins,
    });
    this.selectedTins = [];
  }
  onClose(): void {
    this.manageAccessFacade.resetRemoveAccessView();
    this.dialogRef.close();
  }
}
